import 'babel-polyfill';

import Vue from 'vue';
import App from './App.vue';

import SuiVue from 'semantic-ui-vue';
import 'semantic-ui-css/semantic.min.css';
Vue.use(SuiVue);

// import BootstrapVue from 'bootstrap-vue';
// import 'bootstrap/dist/css/bootstrap.css';
// import 'bootstrap-vue/dist/bootstrap-vue.css';
// Vue.use(BootstrapVue);

import 'vue-awesome/icons';
import Icon from 'vue-awesome/components/Icon';
Vue.component('v-icon', Icon);

import store from './store';

new Vue({
  el: '#app',
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js